import React from "react";
import { Link } from "react-router-dom";
import { wwlogo } from "../../assets";

const RegistrationPage = () => {
  return (
    <div className="max-w-[1200px] mx-auto flex flex-col items-center justify-center min-h-screen lg:py-12 md:py-10 sm:py-8 bg-white">
      <header className="w-full">
        <div className="container mx-auto flex justify-center lg:mt-6 md:mt-4 sm:mt-2 lg:mb-12 md:mb-8 sm:mb-4">
          <Link
            to="/"
            title="WristLink : the global marketplace for luxury watches"
            aria-label="WristLink "
          >
            <img src={wwlogo} alt="WristLink " className="h-24" />
          </Link>
        </div>
      </header>

      <main className="flex-grow lg:w-5/12 md:w-8/12 sm:w-11/12 mx-auto lg:p-12 md:p-8 sm:p-2.5 border border-primarylight  rounded-lg">
        <h1 className="lg:text-3xl sm:text-2xl  mb-6">Create Account </h1>

        <div
          className="notification alert alert-error mb-4 hidden"
          id="js-form-errors"
        >
          <div className="flex items-center">
            <i className="i-close icon-lg text-error"></i>
            <span className="mx-3">Error message goes here.</span>
          </div>
        </div>

        <form
          action="/auth/LoginPage.htm"
          method="post"
          id="js-LoginPage-form"
          className="space-y-4"
        >
          <div className="form-group">
            <label htmlFor="email" className="block text-sm font-medium">
              Email address
            </label>
            <input
              type="text"
              id="email"
              name="email"
              required
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200"
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="block text-sm font-medium">
              Password
            </label>
            <div className="relative">
              <input
                type="password"
                id="password"
                name="password"
                required
                className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200"
                placeholder="Enter your password"
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 flex items-center px-3 text-sm"
                aria-label="Show password"
              >
                <i className="i-preview" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div className="flex  items-start mb-4">
            <div className="form-check">
              <input
                type="checkbox"
                id="userLoginPagePermanently"
                name="LoginPagePermanently"
                className="mr-2"
              />
            </div>
            <p className="text-sm">
              I would like to receive{" "}
              <Link
                to="https://www.chrono24.com/info/datenschutz.htm"
                target="_blank"
                className="underline"
              >
                newsletters
              </Link>{" "}
              about price changes, financial performance updates, the latest
              trends, and new listings via email. I am aware that I can
              unsubscribe from these newsletters at any time.
            </p>
          </div>

          <button
            type="submit"
            className="w-full py-2 bg-black text-white rounded-md hover:bg-primary"
          >
            Register for free
          </button>

          <div className="flex justify-center my-4">
            <span className="text-sm text-gray-500">Or</span>
          </div>

          <div className="flex flex-col space-y-2">
            <button
              type="button"
              className="w-full flex items-center justify-center py-2 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200"
            >
              <img
                src="https://static.chrono24.com/images/icons/svg/google-logo.svg"
                alt="Google"
                className="mr-2"
              />
              Continue with Google
            </button>
            <button
              type="button"
              className="w-full flex items-center justify-center py-2 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200"
            >
              <img
                src="https://static.chrono24.com/images/icons/svg/apple-logo.svg"
                alt="Apple"
                className="mr-2"
              />
              Continue with Apple
            </button>
          </div>
        </form>

        <p className="mt-4 text-sm text-gray-500">
          Already have an account?{" "}
          <Link
            to="/auth/login"
            className="text-black  hover:text-primary underine"
          >
            Log in now
          </Link>
        </p>
      </main>

      <div className="lg:w-5/12 md:w-8/12 sm:w-10/12 p-6 text-sm mx-auto flex justify-center space-x-4">
        <span>
          By registering, you are agreeing to WristLink 's{" "}
          <Link
            to="/info/datenschutz.htm"
            className=" text-black underline hover:text-primary0"
          >
            General Terms and Conditions
          </Link>{" "}
          and{" "}
          <Link
            to="/info/datenschutz.htm"
            className=" text-black underline hover:text-primary0"
          >
            Data Privacy Policy.
          </Link>
        </span>
      </div>

      <footer className="w-full mt-12">
        <div className=" lg:mx-auto md:mx-auto sm:mx-4 lg:text-[16px] md:text-[14px] sm:text-[10px] flex justify-center lg:space-x-4 md:space-x-2 sm:space-x-1">
          <Link
            to="/info/datenschutz.htm"
            className=" text-black  hover:text-primary"
          >
            Data Privacy Policy
          </Link>
          <Link to="/info/agb.htm" className=" text-black  hover:text-primary">
            Terms & Conditions
          </Link>
          <Link
            to="/info/impressum.htm"
            className=" text-black  hover:text-primary"
          >
            Legal Details
          </Link>
          <Link
            to="/info/contact.htm"
            className=" text-black  hover:text-primary"
          >
            Contact
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default RegistrationPage;
